import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import Loader from 'components/Loader';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| GUEST GUARD ||============================== //
// Protects LoginRoutes (routes/LoginRoutes.jsx) - an already-authenticated
// session shouldn't see the login/register forms again.

export default function GuestGuard({ children }) {
  const { status } = useAuth();

  if (status === 'loading') return <Loader />;

  if (status === 'authenticated') {
    return <Navigate to={APP_DEFAULT_PATH} replace />;
  }

  return children;
}

GuestGuard.propTypes = { children: PropTypes.node };
